import { TFeature } from '../../../../../common/types/map';

// Полная пересборка нужна при изменении геометрии и состава пинов.
// Цена участвует, потому что пины без цены не добавляются в ObjectManager.
// Просмотренность, избранное, иконка и выбор обновляются точечно через properties.
export function getFeatureSignature(feature: TFeature): string {
  const { coordinates, pinIndex, pinsCount } = feature.properties;
  const offers = feature.properties.offers
    .map(({ realtyId, cianId, averagePricePerDay }) => `${realtyId}:${cianId}:${averagePricePerDay}`)
    .join(',');

  return `${feature.id}:${coordinates.lat}:${coordinates.lng}:${pinIndex}:${pinsCount}:${offers}`;
}
